import fetch from '../utils/fetch';

const ContactUs = async (name, email, message, number) => {
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name,
      email,
      message,
      contact_number: number,
    }),
  };

  const response = await fetch(`${process.env.SAG_ROOT}/contact-us`, config);

  return response;
};

export default ContactUs;



// WEBPACK FOOTER //
// ./src/actions/contactUs.js